var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9399_173783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9399_173783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 20.9374H20C20.2656 20.9374 20.4883 20.8476 20.6679 20.6678C20.8476 20.488 20.9374 20.2653 20.9374 19.9996C20.9374 19.7338 20.8476 19.5112 20.6679 19.3317C20.4883 19.1522 20.2656 19.0625 20 19.0625H9.99997C9.73434 19.0625 9.5117 19.1524 9.33203 19.3321C9.15234 19.5119 9.0625 19.7346 9.0625 20.0004C9.0625 20.2661 9.15234 20.4887 9.33203 20.6682C9.5117 20.8477 9.73434 20.9374 9.99997 20.9374ZM14.0625 13.4568L12.4086 11.8221C12.2355 11.649 12.0212 11.5605 11.7656 11.5565C11.51 11.5525 11.2844 11.6483 11.0887 11.8439C10.9094 12.0233 10.8197 12.242 10.8197 12.5C10.8197 12.758 10.9102 12.9775 11.0913 13.1586L14.2091 16.2764C14.4351 16.5023 14.6987 16.6153 15 16.6153C15.3012 16.6153 15.5649 16.5023 15.7908 16.2764L18.9086 13.1586C19.0817 12.9855 19.1734 12.7712 19.1838 12.5156C19.1943 12.26 19.1016 12.0344 18.906 11.8387C18.7266 11.6594 18.5112 11.5665 18.2596 11.5601C18.008 11.5537 17.7852 11.641 17.5913 11.8221L15.9374 13.4568V8.74997C15.9374 8.48434 15.8476 8.26169 15.6678 8.082C15.488 7.90233 15.2653 7.8125 14.9996 7.8125C14.7338 7.8125 14.5112 7.90233 14.3317 8.082C14.1522 8.26169 14.0625 8.48434 14.0625 8.74997V13.4568ZM15.0021 26.8749C13.3596 26.8749 11.8159 26.5633 10.3707 25.9399C8.9255 25.3166 7.6684 24.4707 6.59938 23.4021C5.53033 22.3336 4.68401 21.077 4.06041 19.6325C3.4368 18.188 3.125 16.6445 3.125 15.0021C3.125 13.3596 3.43667 11.8159 4.06 10.3707C4.68333 8.9255 5.52927 7.6684 6.59781 6.59938C7.66638 5.53034 8.92293 4.68401 10.3675 4.06041C11.812 3.4368 13.3555 3.125 14.9979 3.125C16.6403 3.125 18.1841 3.43667 19.6293 4.06C21.0744 4.68333 22.3315 5.52927 23.4006 6.59781C24.4696 7.66638 25.3159 8.92293 25.9395 10.3675C26.5631 11.812 26.8749 13.3555 26.8749 14.9979C26.8749 16.6403 26.5633 18.1841 25.9399 19.6293C25.3166 21.0744 24.4707 22.3315 23.4021 23.4006C22.3336 24.4696 21.077 25.3159 19.6325 25.9395C18.188 26.5631 16.6445 26.8749 15.0021 26.8749ZM15 25C17.7916 25 20.1562 24.0312 22.0937 22.0937C24.0312 20.1562 25 17.7916 25 15C25 12.2083 24.0312 9.84372 22.0937 7.90622C20.1562 5.96872 17.7916 4.99997 15 4.99997C12.2083 4.99997 9.84372 5.96872 7.90622 7.90622C5.96872 9.84372 4.99997 12.2083 4.99997 15C4.99997 17.7916 5.96872 20.1562 7.90622 22.0937C9.84372 24.0312 12.2083 25 15 25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9399_173783",
    x1: 5.07727,
    y1: 5.27785,
    x2: 29.5847,
    y2: 21.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c92138f669e501de0c9c88d3ded2896a.svg";
export { ForwardRef as ReactComponent };